import * as React from "react";
import type { SVGProps } from "react";
const SvgCoinsHand = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5 17.5H3.333a.834.834 0 0 1-.833-.833v-5c0-.46.373-.834.833-.834H5c.46 0 .833.374.833.834v5c0 .46-.373.833-.833.833"
      clipRule="evenodd"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10.832 14.167h1.944c.361 0 .712-.117 1-.334l2.014-1.51a1.26 1.26 0 0 1 1.65.118v0a1.26 1.26 0 0 1 0 1.785l-1.728 1.727a3.34 3.34 0 0 1-1.703.912l-2.442.488a3.3 3.3 0 0 1-1.463-.035l-2.208-.551a3.3 3.3 0 0 0-.807-.1H5.832"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10.832 14.167h1.237c.698 0 1.263-.565 1.263-1.263v-.252c0-.58-.394-1.085-.956-1.225l-1.91-.477a4 4 0 0 0-.949-.117v0c-.772 0-1.528.229-2.17.658L5.831 12.5M14.307 4.296a2.365 2.365 0 1 1-3.345 3.345 2.365 2.365 0 0 1 3.345-3.345"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12.193 3.646a2.35 2.35 0 0 0-.656-1.287 2.365 2.365 0 1 0-1.23 3.994"
    />
  </svg>
);
export default SvgCoinsHand;
